module.exports = {
  'pages': {
    'registration': {
      'description': 'If you do not yet have any login data, you can simply register with your acceptance number (AST number). An e-mail will then be sent to you immediately.',
      'title': 'Your learning portal registration',
    }
  },
  'placeholder': {
    'actionCode': 'Collection point number'
  }
};
